import { useState, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export default function DealerRoute() {
  const [state, setState] = useState({ user: undefined, profile: null, loading: true });
  const location = useLocation();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (nextUser) => {
      if (!nextUser) {
        setState({ user: null, profile: null, loading: false });
        return;
      }
      const profileSnap = await getDoc(doc(db, "users", nextUser.uid));
      setState({
        user: nextUser,
        profile: profileSnap.exists() ? profileSnap.data() : null,
        loading: false,
      });
    });
    return () => unsub();
  }, []);

  if (state.loading) return null;
  if (!state.user) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  const isDealer =
    state.profile?.accountType === "dealer" ||
    state.profile?.accountType === "caroffice" ||
    state.profile?.type === "dealer" ||
    state.profile?.type === "caroffice" ||
    state.user?.accountType === "dealer";
  if (!isDealer) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
